import { PLATFORMS } from '../../../models/UserSettings/constants';
import { isVersionGreaterThen } from '../../../utils/comparePluginVersion';
import { getHubspotPageListeners } from './hubspot';
import { getLegacyLinkedinPageIndicators } from './legacy_linkedin';
import { LEGACY_SF_PAGE_LISTENERS } from './legacy_salesforce';
import { getLinkedinPageListeners } from './linkedin';
import { getSalesforcePageListeners } from './salesforce';
const STRING_SELECTORS_VERSION = '10.3.6';
const getSelectors = (inPageListeners, sfPageListeners, hubspotPageListeners) => ({
    [PLATFORMS.LINKEDIN]: inPageListeners,
    [PLATFORMS.LINKEDIN_PUBLIC]: inPageListeners,
    [PLATFORMS.LINKEDIN_RECRUITER_PRO]: inPageListeners,
    [PLATFORMS.LINKEDIN_RECRUITER_LITE]: inPageListeners,
    [PLATFORMS.LINKEDIN_SALES_NAVIGATOR]: inPageListeners,
    [PLATFORMS.SALESFORCE_LIGHTNING]: sfPageListeners,
    [PLATFORMS.SALESFORCE_CLASSIC]: sfPageListeners,
    [PLATFORMS.SCOUT]: { selectors: [], observers: {}, indicators: {} },
    [PLATFORMS.HUBSPOT]: hubspotPageListeners,
});
/**
 * In the newer version of the plugin we support string based indicators (using querySelector)
 * We need to keep the old selectors for users that hasn't updated their plugin to the latest version
 *
 * @param {string} pluginVersion version of the current plugin in store (i.e 10.3.6)
 * @param {string} context is the type of context that the plugin is in (profile/bulk/company)
 * @returns Object of page listeners
 */
export const getVersionedSelectors = (pluginVersion = null, context = 'unknown') => {
    if (pluginVersion && isVersionGreaterThen(pluginVersion, STRING_SELECTORS_VERSION)) {
        return getSelectors(getLinkedinPageListeners(context), getSalesforcePageListeners(context), getHubspotPageListeners(context));
    }
    return getSelectors(getLegacyLinkedinPageIndicators(context), LEGACY_SF_PAGE_LISTENERS, {});
};
